<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >身分證號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field     :rules="[rules.required,rules.idNo1]" :disabled="this.editIndex!=-1"   v-model="idNo"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >醫師代號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field :rules="[rules.required]" :disabled="this.editIndex!=-1"  v-model="codeNo"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >提醒說明文字</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="promptDoc"  v-model="promptDoc"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >標記</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field   v-model="flag"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >備註</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="memo"  v-model="memo"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>


                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>



    </v-card>
</template>

<script>
    export default {
        name: "EditCheckSpecialPatient",
        props:['editIndex','isShow','editObj'],
        data() {
            return {
                idNo:'',//身分證號
                codeNo:'',//科別代號
                promptDoc:'',//Note類別
                memo:'',//就醫者註記說明
                flag:'',// 院區代號
                modifyObj:{},
                rules:{
                    required: value => !!value || '必填.',
                    idNo1:v => /^[A-Z]{1}[A-Z1-9]{1}[0-9]{8}$/.test(v) || '身分證號格式錯誤',
                },
            }
        },
        watch:{
            isShow(val){
                if(val==true&this.editIndex!=-1){
                    this.idNo = this.editObj.idNo==undefined?'':this.editObj.idNo;
                    this.codeNo = this.editObj.codeNo==undefined?'':this.editObj.codeNo;
                    this.promptDoc = this.editObj.promptDoc==undefined?'':this.editObj.promptDoc;
                    this.memo = this.editObj.memo==undefined?'':this.editObj.memo;
                    this.flag = this.editObj.flag==undefined?'':this.editObj.flag;
                }else {
                    this.idNo ='';
                    this.codeNo = '';
                    this.promptDoc = '';
                    this.memo = '';
                    this.flag = 'S';
                }

            }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 特殊患者' : '編輯 特殊患者'
            },
        },
        methods:{
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                if(this.editIndex==-1){ //新增狀態
                    this.modifyObj = {
                        idNo : this.idNo==''||this.idNo==null||this.idNo==undefined?'':this.idNo,
                        codeNo : this.codeNo,
                        promptDoc : this.promptDoc,
                        memo: this.memo,
                        flag: this.flag,

                    }
                }else { //修改狀態
                    this.modifyObj = {
                        idNo : this.idNo==''||this.idNo==null||this.idNo==undefined?'':this.idNo,
                        codeNo : this.codeNo,
                        promptDoc : this.promptDoc ,
                        memo: this.memo,
                        flag: this.flag,
                    }
                }
                // parseFloat(this.sortByNo).toFixed(1);
                if(this.codeNo==''||this.idNo==''){
                    alert('請輸入身分證號和醫師代號')
                }else {
                    this.$emit('save',this.modifyObj);
                }

            }
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }


</style>